import {useHttp} from "./http.hook";
import {Candle} from "../shared/types";

interface IDataChart {
    message: string,
    info: {
        exchangeName: string,
        companyName: string,
        regularMarketPrice: string,
        chart: Candle[]
    }
}

export const useSimulatedTransaction = () => {

    const {loading, request, error, clearError} = useHttp()

    //получения графика
    const getChart = async (ticker: string, timeframe: string) => {
        try {
            const data: IDataChart = await request('/api/simulated-transaction/get-chart', 'POST', {
                ticker: ticker,
                timeframe: timeframe
            })
            return data
        } catch (e) {
            throw new Error('Ошибка получения данных.')
        }
    }

    return {
        loading,
        getChart,
        error,
        clearError
    }
}